// extracted by mini-css-extract-plugin
module.exports = {"Air-bnb-like-slider":"Air-bnb-like-slider_Air-bnb-like-slider__UHu4X"};